import { useEffect } from 'react';

import { ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

import './App.css';
import './css/modal.css';
import './css/tasklocation.css';
import AppRoutes from './Routes.js';
import store from './store/store.js';
import './Style.css';
import history from './utils/history';
import Session from './Session';

function App() {
    // for audio autoplay
    useEffect(() => {
        const handleChunkError = (event) => {
            const message = event?.message || '';
            const isChunkError = message.includes('Loading chunk') || message.includes('ChunkLoadError');
            if (isChunkError) {
                console.warn('Detected chunk load failure. Reloading...');
                window.location.reload();
            }
        };
        window.addEventListener('error', handleChunkError);

        const handleFirstInteraction = () => {
            // Play+immediately pause a silent audio to unlock audio
            const unlockAudio = new Audio('/silent.mp3');
            unlockAudio.play().then(() => unlockAudio.pause());
            document.removeEventListener('click', handleFirstInteraction);
        };

        document.addEventListener('click', handleFirstInteraction);
        return () => {
            document.removeEventListener('click', handleFirstInteraction);
            window.removeEventListener('error', handleChunkError);
        };
    }, []);

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#3b8eb9',
                    colorLink: '#3b8eb9',
                    colorText: '#333333',
                    colorError: '#D92D20'
                },
                components: {
                    Tabs: {
                        itemActiveColor: '#fffff', // active tab text
                        itemSelectedColor: '#fffff' // selected tab text
                    }
                }
            }}>
            <Provider store={store}>
                <Session>
                    <HistoryRouter history={history}>
                        <AppRoutes />
                    </HistoryRouter>
                </Session>
            </Provider>
        </ConfigProvider>
    );
}

export default App;
